import React, { useState, useRef } from "react";
import { useSpring, animated } from "react-spring";
import styled from "styled-components";

const AnimatedSheet = styled(animated.div)`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  touch-action: none;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
`;

const ActionSheet = React.forwardRef(
  ({ closeOnBgTap, sheetStyle, onClose, children }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const touchStartY = useRef(0);
    const touchDisplacement = useRef(0);
    const sheetHeight = window.innerHeight;
    const [{ y }, api] = useSpring(() => ({ y: 0 }));

    React.useImperativeHandle(ref, () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }));

    const handleTouchStart = (e) => {
      touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const displacement = currentY - touchStartY.current;
      if (displacement > 0) {
        touchDisplacement.current = displacement;
        api.start({ y: displacement });
      }
    };

    const handleTouchEnd = () => {
      if (touchDisplacement.current > 100) {
        api.start({
          y: sheetHeight,
          onRest: () => {
            onClose?.();
            setIsOpen(false);
            api.start({ y: 0 });
          },
        });
      } else {
        api.start({ y: 0 });
      }
      touchDisplacement.current = 0;
    };

    if (!isOpen) return null;

    return (
      <AnimatedSheet
        style={{
          transform: y.to((y) => `translateY(${y}px)`),
          ...sheetStyle,
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {children}
        {!closeOnBgTap && <Overlay onClick={onClose} />}
      </AnimatedSheet>
    );
  }
);

export default ActionSheet;
